<template>
    <section class="u-padding-bottom">
        <page-header>
            <slot slot="title">Dashboard {{ fullName }}</slot>
            <slot slot="description">
                <div class="u-flex--push-left">
                    <p class="u-text-uppercase u-font-weight-bold u-font-italic">{{ $t('dashboard.admin.users') }}</p>
                    <router-link class="c-button c-button--outline u-text-uppercase" to="/admin/users">
                        {{ $t('dashboard.admin.to_user_management') }}
                    </router-link>
                </div>
            </slot>
            <slot slot="action">
                <v-customer-search></v-customer-search>
            </slot>
        </page-header>

        <v-overview-list
                prefix="a1"
                data-table="AXWarnings"
                data-pagination="AXWarningsPagination"
                :table-columns="AXWarnings.columns"
                filter-theme="white"
                :btnCopy="false"
                :btnResend="true"
                :btnIgnore="true"
                :btnExport="true"
                :page-size="6"
                :title="$t('ax_warning_overview.page_title')">
        </v-overview-list>

        <hr class="c-seperator c-seperator--large">

        <v-overview-list
                data-table="ClosedPreOrders"
                data-filter="PreOrdersFilters"
                data-pagination="PreOrdersPagination"
                btnViewPath="SalesmanPreOrdersEdit"
                filter-theme="white"
                :filters="PreOrders.filters"
                :table-columns="PreOrders.columns"
                :btnCopy="false"
                :page-size="12"
                :title="$t('preorder_processing_overview.page_title')"
                prefix="lop">
        </v-overview-list>
    </section>
</template>

<script>
    import Vue from 'vue'
    import PageHeader from '@/components/common/PageHeader'
    import VCustomerSearch from '@/components/form/customerSearch/CustomerSearch'
    import VOverviewList from '@/components/OverviewList'

    export default {
        props: {},
        components: {
            PageHeader,
            VCustomerSearch,
            VOverviewList
        },
        data() {
            return {}
        },
        computed: {
            AXWarnings() {
                return {
                    columns: [
                        { value: 'Warning', name: '', type:'Tooltip', sortable: false },                        
                        { value: 'Type', name: this.$t('ax_warning_overview.columns.type'), sortable: false },                        
                        { value: 'CustomerAltKey', name: this.$t('ax_warning_overview.columns.customer_key'), sortable: false },
                        { value: 'CustomerName', name: this.$t('ax_warning_overview.columns.customer'), sortable: false },
                        { value: 'OrderReference', name: this.$t('ax_warning_overview.columns.order_reference'), sortable: false },
                        { value: 'ProcessDate', name: this.$t('ax_warning_overview.columns.process_date'), type:'Date', sortable: false},
                        //{ value: 'Type', name:'', sortable: false, type:'ResendToAX' },
                    ]
                }
            },
            PreOrders() {
                return {
                    filters: [
                        { name: this.$t('preorder_overview.filters.brands'), value: 'Brands', single: 'brand', width:150 },
                        { name: this.$t('preorder_overview.filters.collections'), value: 'Collections', single: 'collection', width:150 },
                        { name: this.$t('preorder_overview.filters.customer'), value: 'Customers', single: 'customer', width:150 },
                        { name: this.$t('preorder_overview.filters.system_states'), value: 'SystemStates', single: 'systemState', width:200 }
                    ],
                    columns: [
                        { value: 'SheetName', name: this.$t('preorder_overview.columns.name') },
                        { value: 'CustomerAltKey', name: this.$t('preorder_overview.columns.customer_key') },
                        { value: 'Customer', name: this.$t('preorder_overview.columns.customer') },
                        { value: 'InternalCustomerReference', name: this.$t('preorder_overview.columns.internal_customer_ref') },   
                        { value: 'SalesMan', name: this.$t('preorder_overview.columns.salesman') },                     
                        { value: 'SystemState', name: this.$t('preorder_overview.columns.system_state') },
                        { value: 'ProcessDate', name: this.$t('preorder_overview.columns.process_date'), type: 'Date' }
                    ]
                };
            },            
            fullName() {
                return this.$store.getters.userInfo.firstName + ' ' + this.$store.getters.userInfo.lastName;
            }
        },
        methods: {},
    }
</script>



// WEBPACK FOOTER //
// src/views/admin/AdminZone.vue